import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';

import { InvitationStatusType } from '@vi-iot/client';

import { GatewayInvitationsState, SearchType } from '@store';

import { GatewayInvitationsService } from '../../../../+installations/installation/gateway-features-panel/gateway-invitations.service';
import { GTMService } from '../../../../shared/services';

@Component({
  selector: 'app-gateway-invitation-list',
  templateUrl: './gateway-invitation-list.component.html',
  styleUrls: ['./gateway-invitation-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GatewayInvitationListComponent implements OnInit, OnDestroy {
  invitations$: Observable<GatewayInvitationsState>;

  // required by infinite scroll component
  searchType$ = of(SearchType.gatewayInvitations);

  statusFilters: { value: string; name: string }[];

  initialFilter = '';

  status: InvitationStatusType;

  // loading indicator trigger
  nextBatch = false;

  // page size
  limit = 20;

  // list item height - required by infinite scroll
  itemSize = 75;

  constructor(
    private gatewayInvitationsService: GatewayInvitationsService,
    private dialogRef: MatDialogRef<GatewayInvitationListComponent>,
    private gtmService: GTMService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      installationId: number;
      customerNumber: string;
    }
  ) {
    this.statusFilters = this.gatewayInvitationsService.statusFilters;
  }

  ngOnInit(): void {
    this.gatewayInvitationsService.listGatewayInvitations({
      installationId: this.data.installationId,
      customerNumber: this.data.customerNumber,
      status: null,
      limit: this.limit,
      offset: 0,
    });
    this.invitations$ = this.gatewayInvitationsService.selectInvitations();
  }

  ngOnDestroy(): void {
    this.gatewayInvitationsService.clearStore();
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onFilterChange(status: InvitationStatusType): void {
    this.status = status;

    this.gatewayInvitationsService.filterByStatus({
      installationId: this.data.installationId,
      customerNumber: this.data.customerNumber,
      limit: this.limit,
      offset: 0,
      status,
    });
    this.gtmService.track('onSelect', `${status} invitation status filter`, 'Invitation list');
  }

  onNextBatchChange($event: any): void {
    this.nextBatch = $event;
  }

  onFetchNext({ limit, offset }: { offset?: number; limit: number; cursor?: string }): void {
    this.gatewayInvitationsService.listGatewayInvitations({
      installationId: this.data.installationId,
      customerNumber: this.data.customerNumber,
      status: this.status,
      limit,
      offset,
    });
  }
}
